// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='waive' class="box">
  <sub-header header="'Waive'"></sub-header>
    <form name="singleWaiveForm">
      <form-section>

        <loan-pre-terminate
          ng-if="\$ctrl.loan"
          loan="\$ctrl.loan"
          max-values='\$ctrl.maxValues'
          waive-request='\$ctrl.waiveRequest'
          priority-amortization-ids='\$ctrl.amortizationIds'
          payment-request='\$ctrl.empty'
          form-name="singleWaiveForm"
          waive-only="true"
        >

        </loan-pre-terminate>
        <!--For validation purpose only-->
        <input ng-if="\$ctrl.waiveRequest.waiveParts.length == 0" disabled class="hidden-element" ng-required="true" ng-model="nonExistingValue"/>

        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.pay()" ng-disabled="!singleWaiveForm.\$valid || !\$ctrl.loan">
            Confirm waive
          </button>
        </div>

        <div class="clearfix"></div>
      </form-section>
    </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/waive-penalties/waive-amortization.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;